// Общий счётчик непрочитанного.
//
// Одно и то же число показывают несколько мест сразу: иконка в шапке, вкладка
// в полосе кабинета и раздел нижней панели. Каждый значок опрашивал сервер сам,
// и на странице профиля к сообщениям уходило два одинаковых запроса.
//
// Здесь на адрес приходится один опрос: подписчики получают последнее число
// сразу при подписке, а опрос идёт, пока жив хоть один из них.

import { get } from "./http.js";
import { Poller } from "./poller.js";

/** @type {Map<string, {poller: Poller, subscribers: Set<Function>, value: number|null}>} */
const feeds = new Map();

/**
 * Подписывает на число непрочитанного по адресу.
 *
 * @param {string} url адрес, отдающий JSON со счётчиком
 * @param {string} key поле счётчика в ответе
 * @param {number} interval пауза между опросами, мс
 * @param {(count: number) => void} onChange вызывается на каждое новое число
 * @returns {() => void} отписка
 */
export function subscribeUnread(url, key, interval, onChange) {
  const id = `${url}|${key}`;
  let feed = feeds.get(id);

  if (!feed) {
    feed = { poller: null, refresh: null, subscribers: new Set(), value: null };
    feed.refresh = async () => {
      const data = await get(url);
      feed.value = Number(data?.[key] || 0);
      feed.subscribers.forEach((callback) => callback(feed.value));
    };
    feed.poller = new Poller(feed.refresh, interval);
    feeds.set(id, feed);
  }

  feed.subscribers.add(onChange);

  // Новый значок не ждёт следующего тика: известное число он получает сразу,
  // а первый опрос запускается только вместе с первым подписчиком.
  if (feed.value !== null) onChange(feed.value);
  if (feed.subscribers.size === 1) {
    feed.refresh().catch(() => {});
    feed.poller.start();
  }

  return () => {
    feed.subscribers.delete(onChange);
    if (feed.subscribers.size === 0) {
      feed.poller.stop();
      feeds.delete(id);
    }
  };
}
